<template>
    <v-select class="widthmy"  :options="['Canada', 'United States','amila']" ></v-select>
</template>
<script>
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
export default {
    data() {
        return{

        }
    },
    components:{
        vSelect
    },
    methods:{
        dropdownShouldOpen(VueSelect) {
      if (this.options !== null) {
        return VueSelect.open
      }

      return VueSelect.search.length !== 0 && VueSelect.open
    },
  
    }
}
</script>
<style>

.widthmy {
    width: 50%;
}
</style>
